import {http} from "@/assets/utils/api";

/**
 * 店铺收藏关系
 */
export const getCollectInfo = (params) => http.get('/collect/getAssociatedIdsState',{params});

/**
 * 收藏
 */
export const collectShop = (data) => http.post('/collect/collect',data);

/**
 * 加入购物车
 */
export const addCar = (data) => http.post('/yymCourseCart/add',data);

/**
 * 移除购物车
 * @returns 
 */
export const removeCar = (id) => http.post('/yymCourseCart/delete/'+id);

/**
 * 购物车列表
 */
export const getCarList = (params) => http.get('/yymCourseCart/getAll',{params});

/**
 * 获取支付二维码
 */
export const getPayQrcode = (data) => http.post('/yymCourseOrder/getPayQrcode',data);

/**
 * 查询订单是否支付成功
 */
export const checkOrderIspay = (data) => http.post('/yymCourseOrder/checkPaymentState',data);

/**
 * 查询订单详情
 */
export const getOrderInfo = (orderId) => http.get('/yymCourseOrder/getInfoById/'+orderId);

/**
 * 取消订单
 */
export const cancelOrder = (data) => http.post('/yymCourseOrder/cancel',data);

/**
 * 优惠券列表
 */
export const getCouponList = (params) => http.get('/coupon/getMyShopCouponList',{params});